// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1ACIr","additionalInfo":"AgreementModal_additionalInfo__1IIOS"};